import * as React from 'react';
import { SVGProps } from 'react';

const IconFilePresentationSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M14 10V3a7 7 0 0 1 7 7h-7Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4v8h8a8.001 8.001 0 0 1-16 0 8.001 8.001 0 0 1 8-8Zm-1 9h7.93A7.001 7.001 0 0 1 5 12a7.002 7.002 0 0 1 6-6.93V13Z"
    />
  </svg>
);
export default IconFilePresentationSizeM;
